import { observable, makeAutoObservable } from 'mobx';

export class EventSettingsState {
    @observable errorMessage: string | null = null;

    setErrorMessage = (message: string): void => {
        this.errorMessage = message;
    };

    clearErrorMessage = (): void => {
        this.errorMessage = null;
    };

    constructor() {
        makeAutoObservable(this);
    }
}
